const loader = `<svg class="flo-spinner flo-loader" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.50004 1.33325V3.99992M8.50004 11.9999V14.6666M4.50004 7.99992H1.83337M15.1667 7.99992H12.5M13.219 12.7189L11.3334 10.8333M13.219 3.33321L11.3334 5.21883M3.78109 12.7189L5.66671 10.8333M3.78109 3.33321L5.66671 5.21883" stroke="#111" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

const userIconDesktop = `<svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1997_6385)" stroke-width="1"><rect width="29" height="29"/><g stroke="currentColor"><path d="M4.83331 25.375V22.9583C4.83331 21.6765 5.34254 20.4471 6.24896 19.5407C7.15539 18.6342 8.38477 18.125 9.66665 18.125H12.6875"/><path d="M14.5 13.2917C17.1694 13.2917 19.3334 11.1277 19.3334 8.45833C19.3334 5.78896 17.1694 3.625 14.5 3.625C11.8306 3.625 9.66669 5.78896 9.66669 8.45833C9.66669 11.1277 11.8306 13.2917 14.5 13.2917Z"/></g><path d="M21.3865 12.3001L14.1711 20.6166L20.5136 20.7427L19.6967 26.3665L26.9122 18.05L20.5697 17.9238L21.3865 12.3001Z" fill="#01CCA7" stroke="#01CCA7" stroke-width="0.5"/></g></svg>`;

// --- Login button (not logged in) ---

const shopfloNotLoggedIcon = `<div id="flo-login-button-header-logo" style="cursor:pointer;display:flex;align-items:center;">${userIconDesktop}</div>`;

// --- Dropdown drawer (logged in, desktop) ---

const drawerhtmlDesktop = `
  <div id="shopflo-drawer-desktop" style="display:none;">
    <ul>
      <a id="account-button-desktop" href="javascript:void(0);" onclick="event.stopPropagation(); handleShopifyLogin(event,'/account');">
        <p>Account</p>
        <div class="loader-container">${loader}</div>
      </a>
      <button id="logout-button-desktop" onclick="event.stopPropagation(); handleLogout();">
        <p>Logout</p>
      </button>
    </ul>
  </div>`;

// --- Logged-in icon set (desktop) — user icon + X toggle ---

const shopfloLoggedInIcon = `
  <div id="loggedin-icons" style="display:none;">
    <div id="icon-close-shopflo" onclick="handleDrawer()" style="height:25px;width:25px;cursor:pointer;display:none;">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div style="cursor:pointer;display:flex;" onclick="handleDrawer()" id="icon-shopflo">${userIconDesktop}</div>
  </div>`;

// Toggles desktop dropdown open/closed
function handleDrawer() {
  if (window.innerWidth <= 699) return;

  var drawer = document.getElementById('shopflo-drawer-desktop');
  var openIcon = document.getElementById('icon-shopflo');
  var closeIcon = document.getElementById('icon-close-shopflo');

  if (!drawer || !openIcon || !closeIcon) return;

  var isOpen = window.getComputedStyle(drawer).display === 'block';
  drawer.style.display = isOpen ? 'none' : 'block';
  openIcon.style.display = isOpen ? 'flex' : 'none';
  closeIcon.style.display = isOpen ? 'none' : 'flex';
}

const SHOPFLO_WAIT_MS = 2500;
const SHOPFLO_POLL_MS = 50;

// Never /account/login. That is the dead-end route snippets/account-gate-redirect.liquid
// exists to catch, so navigating to it turns a slow bundle into a trip to the homepage.
const ACCOUNT_PATH = '/account';

// `handleShopifyLogin` is assigned inside the bundle's init routine, in the same
// synchronous block that binds the account elements. Because the bundle now loads
// after window load, that routine always runs with readyState already "complete",
// so it scans once and finds everything — the global existing is a reliable proxy
// for "Shopflo has bound the account elements".
const isShopfloReady = () => typeof window.handleShopifyLogin === 'function';

const waitForShopflo = (timeoutMs) =>
  new Promise((resolve) => {
    if (isShopfloReady()) {
      resolve(true);
      return;
    }

    const startedAt = performance.now();
    const poll = () => {
      if (isShopfloReady()) {
        resolve(true);
      } else if (performance.now() - startedAt >= timeoutMs) {
        resolve(false);
      } else {
        setTimeout(poll, SHOPFLO_POLL_MS);
      }
    };

    setTimeout(poll, SHOPFLO_POLL_MS);
  });

// handleShopifyLogin is Shopflo's own entry point, and the only thing that turns
// a Shopflo session into a *Shopify* customer session. A Flo access token proves
// the visitor is logged into Shopflo and nothing more, so it may decide what a
// control says — never whether this call can be skipped. Reaching /account
// without it is exactly what produces Shopify's /account/login?return_url= bounce.
const runShopifyLogin = (event, path) => {
  try {
    handleShopifyLogin(event, path);
    return true;
  } catch (_) {
    return false;
  }
};

// Handles the account tap for every entry point that stays a plain server-rendered
// <a> — the bottom nav and the hamburger drawer — whenever Shopflo has not already
// claimed it. That gap is not an edge case: bottom-nav-bar.js replaces the nav's
// innerHTML on every cart:rendered, discarding whatever the bundle had bound and
// leaving behind a fresh anchor its one init scan will never look at again.
//
// preventDefault only. Propagation is left intact so the click still reaches the
// analytics listeners bound on document — see the delegation comment below.
const openAccount = async (event, element) => {
  event.preventDefault();

  if (!isShopfloReady()) {
    element.classList.add('shopflo-pending');
    window.loadShopflo?.();

    const ready = await waitForShopflo(SHOPFLO_WAIT_MS);
    element.classList.remove('shopflo-pending');

    // A redirect rather than a re-dispatched click: the original gesture is
    // spent by now, so a synthetic click could be blocked as untrusted. Shopflo
    // SSO still runs on the destination, and if Shopify bounces it for want of
    // a session the gate now lets that login page render instead of going home.
    if (!ready) {
      window.location.href = ACCOUNT_PATH;
      return;
    }
  }

  if (!runShopifyLogin(event, ACCOUNT_PATH)) window.location.href = ACCOUNT_PATH;
};

// The desktop header is not a bare anchor — injectShopfloDesktop swaps it for
// Shopflo's own widget, whose inner controls (Account, Logout) carry inline
// handlers. So it carries no data-shopflo-account-tap and the delegated handler
// never sees it; this bridges the window before the bundle initialises instead,
// since the listener Shopflo attaches during that wait cannot fire for a click
// already dispatched. It steps aside the moment Shopflo is up, which is what
// keeps Logout working.
const bindDesktopBridge = (element) => {
  if (!element) return;

  element.addEventListener('click', async (event) => {
    if (isShopfloReady()) return;

    event.preventDefault();
    element.classList.add('shopflo-pending');
    window.loadShopflo?.();

    const ready = await waitForShopflo(SHOPFLO_WAIT_MS);
    element.classList.remove('shopflo-pending');

    if (ready) {
      runShopifyLogin(event, ACCOUNT_PATH);
    } else {
      window.location.href = ACCOUNT_PATH;
    }
  });
};

// Replaces the desktop header account link with the Shopflo desktop widget
const injectShopfloDesktop = (targetElement) => {
  const wrapper = document.createElement('div');
  wrapper.className = 'header--icon';
  wrapper.innerHTML = `${shopfloNotLoggedIcon}${shopfloLoggedInIcon}${drawerhtmlDesktop}`;
  targetElement.parentElement.replaceChild(wrapper, targetElement);
  bindDesktopBridge(wrapper);
};

// Delegated on document so one listener covers every bare account anchor and keeps
// working after bottom-nav-bar.js re-renders the nav from cart:rendered.
//
// Bubble phase, deliberately. The bundle binds a[href="/account"] directly, and
// element listeners run before document-bubble ones — so if Shopflo already owns
// this tap it has called preventDefault by the time we see it, and we stand down.
// Capture phase would need stopImmediatePropagation to avoid double-handling, and
// that aborts the whole dispatch: GTM, Clarity and the pixels would never see the
// click. Standing down on defaultPrevented gets the same protection for free.
document.addEventListener('click', (event) => {
  if (event.defaultPrevented) return;

  const accountLink = event.target.closest?.('[data-shopflo-account-tap]');
  if (accountLink) openAccount(event, accountLink);
});

document.addEventListener('DOMContentLoaded', () => {
  // Desktop: a[data-shopflo-account] in sections/header.liquid
  const desktopEl = document.querySelector('a[data-shopflo-account]');
  if (desktopEl) injectShopfloDesktop(desktopEl);

  // The drawer row is server-rendered from the menu, so its label says "Log in"
  // until the Shopflo session is known. The tap itself is delegated above.
  const drawerAccountTitle = document.querySelector(
    '[data-shopflo-drawer-account] .header-drawer__row-title'
  );
  if (drawerAccountTitle) drawerAccountTitle.textContent = 'Account';
});
